<template>
  <v-row>
    <v-col cols="12">
      <app-comment :body="JSON.parse(questions[0].content)">
        <template #title>
          Prompts
        </template>
      </app-comment>
    </v-col>
    <v-col cols="12">
      <app-comment class="mt-7">
        <template v-slot:title>Answer</template>
        <template v-slot:body>
          <app-body-answer
            v-model="answer.content"
            placeholder
            :readonly="finished"
            :finished="finished"
            :teacher="JSON.parse(questions[0].good_answer)"
          />
          <v-row justify="center" class="mt-6">
            <v-btn
              v-if="!finished"
              small
              depressed
              width="100"
              :loading="loading"
              :disabled="finished"
              class="white--text text-capitalize"
              color="#29284c"
              @click="onFinish"
              >Finish</v-btn
            >
            <ProgressResetButton
              v-else
              :stepType="stepType"
              :stepUuid="stepUuid"
              @reset="onReset"
            />
          </v-row>
        </template>
      </app-comment>
    </v-col>
  </v-row>
</template>
<script>
import BodyAnswer from '@/components/Lessons/Lesson/components/BodyAnswer';
import Comment from '@/components/Lessons/Lesson/components/Comment';
import studentMixin from '@/mixins/studentMixin';
import { getAnswer, postAnswer } from '@/api/api';
import ProgressResetButton from '@/components/Utils/ProgressResetButton.vue';

export default {
  components: {
    appComment: Comment,
    appBodyAnswer: BodyAnswer,
    ProgressResetButton,
  },
  mixins: [studentMixin],
  props: {
    stepUuid: {
      type: String,
      required: true,
    },
    questions: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      showAnswers: true,
      answer: {},
      loading: false,
      finished: false,
    };
  },
  computed: {
    stepType() {
      if (this.$route.name === 'guided-lesson') {
        return 'TEACH_EXERCISE';
      }
      return 'GRAMMAR_EXERCISE';
    },
  },
  methods: {
    async onFinish() {
      this.loading = true;
      if (!this.finished && !this.answer.uuid) {
        const response = await postAnswer(this.answer);
        if (response) {
          this.answer = response.data;
        }
      }
      this.finished = true;
      this.loading = false;
      this.$emit('finished');
    },
    async create() {
      this.loading = true;
      const response = await getAnswer({
        question__uuid: this.questions[0].uuid,
        student__email: this.student.email,
      });
      if (response.data.count) {
        [this.answer] = response.data.results;
        this.finished = true;
        this.$emit('already-finished');
      } else
        this.answer = {
          question: this.questions[0].uuid,
          student: this.student.email,
          content: '',
        };
      this.loading = false;
    },
    onReset() {
      this.finished = false;
      this.answer.content = '';
      this.answer.uuid = undefined;
      this.$emit('reset');
    },
  },
  watch: {
    questions() {
      this.create();
    },
  },
  async created() {
    await this.create();
  },
};
</script>
